import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { ContentCopy, QrCode2 } from "@mui/icons-material";
import { useState } from "react";
import QrCodeDialog from "./QrCodeDialog";

const LinkBox: React.FC<{ link: string, downloadfilename?: string, title?: string }> = ({ link, downloadfilename, title }) => {
    const [showQr, setQr] = useState(null as string | null);

    return <Box display="flex" alignContent="center" alignItems="center">
        <Box minWidth={0} maxWidth="300px">
            <Tooltip arrow title={
                <a href={link} target="nutilogi_target">{link}</a>
            }>
                <Typography noWrap={true}>{link}</Typography>
            </Tooltip>
        </Box>
        <IconButton
            onClick={() => {
                navigator.clipboard.writeText(link);
            }}
            size="large"
        >
            <ContentCopy />
        </IconButton>
        <IconButton
            onClick={() => {
                setQr(link);
            }}
            size="large"
        >
            <QrCode2 />
        </IconButton>
        {showQr !== null && (
            <QrCodeDialog
                title={title}
                message={showQr}
                downloadfilename={downloadfilename}
                onClose={() => {
                    setQr(null);
                }}
            />
        )}
    </Box>;
}


export default LinkBox